module.exports = __webpack_public_path__ + "img/secondary_9x2_z18.f1683184.svg";